module.exports = __webpack_public_path__ + "img/cloth_g3_item_18.5a5cdc24.svg";